<template>
  <div class="app-container">
    <!--加载进度-->
    <van-loading v-if="!isLoaded" class="loading" />
    <!--加载失败-->
    <div v-else-if="errorMessage" class="error-message">
      错误：{{ errorMessage }}
    </div>
    <!--加载成功-->
    <template v-else>
      <van-cell-group title="委托事项列表">
        <van-cell
          title="委托申请"
          label="用于委托申请"
          size="large"
          to="/delegateApplication/Add"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
        <van-cell
          title="不动产具结保证书"
          label="用于不动产具结保证书"
          size="large"
          to="/delegateApplication/RealEstateAdd"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
        <van-cell
          title="继承具结保证书"
          label="用于继承具结保证书"
          size="large"
          to="/delegateApplication/InheritAdd"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
        <van-cell
          title="婚姻状况承诺书"
          label="用于婚姻状况承诺书"
          size="large"
          to="/delegateApplication/MarriageAdd"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
        <van-cell
          title="土地状况承诺书"
          label="用于土地状况承诺书"
          size="large"
          to="/delegateApplication/LandAdd"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
        <van-cell
          title="未成年人权益不动产承诺书"
          label="用于未成年人权益不动产承诺书"
          size="large"
          to="/delegateApplication/MinorAdd"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="red"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
      </van-cell-group>
    </template>
  </div>
</template>

<script>
import { getApplicationShortcutList } from '@/api/application'

export default {
  filters: {
    iconName(name) {
      return name || 'all'
    },
    iconColor(color) {
      return color || '#666'
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      shortcuts: []
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData() {
      getApplicationShortcutList({
        isEnabled: true
      }).then(({ data }) => {
        this.shortcuts = data
        this.isLoaded = true
      }).catch(error => {
        this.errorMessage = error.message
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #ededed;
  .loading{
    padding-top: 15px;
    text-align: center;
  }
  .error-message{
    color: #ee0a24;
    padding-top: 15px;
    text-align: center;
  }
  .van-cell:not(:last-child)::after {
    left: 54px;
    border-bottom: 1px solid #d9d9d9;
  }
}
</style>
